
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/documents-test",
      function () {
        return require("private-next-pages/documents-test.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/documents-test"])
      });
    }
  